module.exports = __webpack_public_path__ + "static/media/ios-icon.02f9d709.svg";